import { AxiosError } from 'axios';

export interface ApiErrorResponse {
  error: string;
  message: string;
  code: string;
  [key: string]: any;
}

export class ApiError extends Error {
  readonly code: string;
  readonly error: string;
  readonly name: string;
  readonly status: number;
  readonly payload: Record<string, any>;
  readonly response: Record<string, any>;

  constructor({
    message,
    code,
    error,
    name,
    status,
    payload,
    response,
  }: {
    message: string;
    code: string;
    error: string;
    name: string;
    status: number;
    payload: Record<string, any>;
    response: Record<string, any>;
  }) {
    super(message);
    this.code = code;
    this.error = error;
    this.name = name;
    this.status = status;
    this.payload = payload;
    this.response = response;
  }

  static fromAxiosError(error: AxiosError<ApiErrorResponse>): ApiError {
    if (error.response) {
      const response = error.response.data || {};
      const payload = error.config?.data ? JSON.parse(error.config.data) : {};

      return new ApiError({
        message: response.message || error.message,
        code: response.code || String(error.response.status),
        error: response.error || error.message,
        name: 'API Error',
        status: error.response.status,
        payload,
        response,
      });
    }

    if (error.request) {
      return new ApiError({
        message: 'Network Error: No response received',
        code: 'NETWORK_ERROR',
        error: 'Network Error',
        name: 'Network Error',
        status: 0,
        payload: {},
        response: {},
      });
    }

    return new ApiError({
      message: error.message,
      code: 'REQUEST_SETUP_ERROR',
      error: error.message,
      name: 'Request Setup Error',
      status: 0,
      payload: {},
      response: {},
    });
  }
}

export const onError = (error: AxiosError<ApiErrorResponse>): never => {
  throw ApiError.fromAxiosError(error);
};
